import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
// Change the icons, function names, and parameters
// to fit the Braves game logger topic and schema.
export const AddGamePageTable = () => {
    const [stadium, setStadium] = useState('');
    const [bravesScore, setBravesScore] = useState('');
    const [date, setDate] = useState('');
    const redirect = useNavigate();
    const addGame = async () => {
        const newGame = { stadium, bravesScore, date };
        const response = await fetch('/games', {
            method: 'post',
            body: JSON.stringify(newGame),
            headers: { 'Content-Type': 'application/json', },
        });
        if (response.status === 201) {
            alert("Game successfully added!");
        } else {
            alert(`Error adding game. Server responded with status code ${response.status}. Please try again.`);
        }

        redirect("/");
    };
    return (
        <>
            <article>
                <h2>Add a New Game to the Tracker</h2>
                <p><p>This page allows you to add details about a new game including the stadium,
                    Braves' score, and date of the game. Fill in the required fields and click "Add"
                    to submit the information.</p>
                </p>
                <table id="games">
                    <thead>
                        <tr>
                            <th>Game Stadium</th>
                            <th>Braves Score</th>
                            <th>Date of the Game</th>
                            <th>Submit Changes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <input type="text" placeholder="Enter the Stadium..." value={stadium} onChange={e => setStadium(e.target.value)} id="stadium" />
                            </td>
                            <td>
                                <input type="number" value={bravesScore} placeholder="Enter Braves Score..." onChange={e => setBravesScore(e.target.value)} id="bravesScore" />
                            </td>
                            <td>
                                <input type="date" value={date} onChange={e => setDate(e.target.value)} id="date" />
                            </td>
                            <td>
                                <button type="submit" onClick={addGame} id="submit">Add</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </article>
        </>
    );
}
export default AddGamePageTable;
